<template>
  <div class="adddorm-form">
    <el-dialog title="提示" :visible="dormFormShow" width="400px" @close="dialogClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="宿舍号" label-width="100px" prop="dormName">
          <el-input
            v-model="ruleForm.dormName"
            autocomplete="off"
            placeholder="请输入宿舍号"
            style="width: 235px"
          ></el-input>
        </el-form-item>
        <el-form-item label="宿舍楼" label-width="100px" prop="blockName">
          <el-input
            v-model="ruleForm.blockName"
            autocomplete="off"
            placeholder="请输入宿舍楼"
            style="width: 235px"
          ></el-input>
        </el-form-item>
        <el-form-item label="宿舍规格" label-width="100px" prop="dormType">
          <!-- <el-input
            v-model="ruleForm.dormType"
            autocomplete="off"
            placeholder="请输入宿舍规格"
          ></el-input> -->
          <el-select v-model="ruleForm.dormType" placeholder="请选择宿舍规格">
            <el-option
              v-for="item in dictTypeList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼层" label-width="100px" prop="level">
          <el-input
            v-model="ruleForm.level"
            autocomplete="off"
            placeholder="请输入楼层"
            style="width: 235px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="form-btn">
        <!-- <el-button @click="dialogClose">取 消</el-button> -->
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["dormFormShow", "dictTypeList"],
  data() {
    return {
      ruleForm: {
        blockName: "",
        dormName: "",
        dormType: "",
        level: "",
      },
      rules: {
        dormName: [{ required: true, message: "请输入宿舍号", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.reset();
      this.$emit("update:dormFormShow", false);
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("formSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    reset() {
      this.ruleForm = {
        blockName: "",
        dormName: "",
        dormType: "",
        level: "",
      };
      this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./adddorm-form.scss";
</style>
